import React, { Component } from "react";
import AILogo from "./icons/AILogo.svg";
import SidebarIcon from "./icons/SidebarIcon.svg";
import MenuIcon from "./icons/MenuIcon.svg";

import { Link } from "react-router-dom";

export default class SideBar extends Component {
  state = {
    sidebarOpen:
      this.props.location == undefined
        ? false
        : this.props.location.state.sidebarOpen,
    selected: "service",
    user: {},
    type: "",
    services: [],
    avatarURL: "",
    config: this.props.config,
  };

  componentWillMount() {
    let { services, config } = this.props;
    let { user, type } = config;
    if (user.avatar_url && user.avatar_url.length > 0) {
      this.setState((state) => ({
        ...state,
        avatarURL: `${user.avatar_url}?${
          user.sas_token
        }&t${new Date().getTime()}`,
      }));
    } else {
      let avatarURL = `/images/${user.first_name?.[0].toLowerCase()}.PNG`;
      this.setState((state) => ({
        ...state,
        avatarURL: avatarURL,
      }));
    }
  }

  toggleSidebarMode = () => {
    this.setState((state) => ({
      ...state,
      config: {
        ...state.config,
        mode: state.config.mode == "shrunk" ? "expanded" : "shrunk",
      },
    }));
    this.props.parentSidebarSwitch();
  };

  render() {
    let { services, config, showMainDashboardIcons } = this.props;
    let { user, type } = config;
    config.mode = "sidebar-expanded";

    return (
      <div
        className={
          config.mode == "shrunk" ? "sidebar-shrunk" : "sidebar-expanded"
        }
        style={{
          paddingTop: "0px",
          backgroundColor: this.props.backgroundColor
            ? this.props.backgroundColor
            : "white",
          height: this.props.height || "",
        }}
      >
        <div style={{ display: "flex", height: "40px" }}>
          <div style={{ height: "40px", transition: "0.3s", margin: "auto" }}>
            <img
              src={this.props.AeroMeghLogo ? this.props.SidebarIcon : SidebarIcon}
              style={{ width: "65px", height: "20px", marginTop: "15px" }}
            />
          </div>
        </div>
        <ul className="sidebar-nav" id="sidebar-nav">
          {config.options
            .filter((el) => {
              return el.text !== "Help";
            })
            .map((el) => {
              if (el.text != "hr") {
                el.text = el.text.replace(/\b[a-z]/g, (match) =>
                  match.toUpperCase()
                );
              }
              return el;
            })
            .map((item) => {
              return item.text == "hr" ? (
                <hr
                  className={
                    config.mode == "shrunk"
                      ? "sidebar-shrunk-separator"
                      : "sidebar-expanded-separator"
                  }
                />
              ) : (
                <div
                  style={{
                    borderLeft: `solid 2px ${
                      item.selected
                        ? this.props.borderColor
                          ? this.props.borderColor
                          : "#2989CF"
                        : "transparent"
                    }`,
                  }}
                >
                  <li>
                    <Link
                      to={{
                        pathname: item.path,
                        state: {
                          config,
                          sidebarMode: config.mode,
                          user,
                          type,
                        },
                      }}
                    >
                        <img class="sidebar-icon" src={item.icon} alt="Menu Icon" />
                        <p style={{fontSize:"12px"}}>{item.text}</p>
                    </Link>
                  </li>
                </div>
              );
            })}
        </ul>
      </div>
    );
  }
}
